import style from './index.module.css'

import React from 'react'

import type { NativeTag } from 'types/track'

import { Flex } from 'components/ds'
import HighlightedText from 'components/ui/highlighted-text'

import CheckboxRow from '../components/checkbox-row'

type TagsCheckboxProps = {
  tagOptions: NativeTag[]
  onCheckChange: (_checked: string | boolean, _tag: NativeTag) => void
  value?: number[]
  searchValue?: string
}

const TagsCheckbox = ({
  tagOptions,
  onCheckChange,
  value,
  searchValue,
}: TagsCheckboxProps) => {
  return (
    <Flex direction="column" width="100%">
      {tagOptions.map(tag => (
        <CheckboxRow
          key={tag.id}
          checked={value?.includes(tag.id) ?? false}
          onCheckedChange={checked => onCheckChange(checked, tag)}
          onClick={() => onCheckChange(!value?.includes(tag.id), tag)}
          className={style.Checkbox_RowContainer}
        >
          <HighlightedText
            text={tag.name}
            highlights={searchValue ? [searchValue] : []}
            customColors={{
              background: 'var(--disco-yellow)',
            }}
          />
        </CheckboxRow>
      ))}
    </Flex>
  )
}

export default TagsCheckbox
